import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { ShowAlert } from "../../utils/functions";
import { useStores } from "../../stores/root-store";
import { Modal } from "react-bootstrap";
import { ApiResponse, IModal } from "../../stores";

interface IChangePasswordAdmin extends IModal {
  user: { userId: string; userName: string };
}

const ChangePasswordAdmin = observer(
  ({ show, setShowModal, user }: IChangePasswordAdmin) => {
    const { userStore } = useStores();
    const { changePasswordByUserId } = userStore;

    const [newPassword, setNewPassword] = useState("");
    const [isFormValid, setIsFormValid] = useState(false);

    useEffect(() => {
      setIsFormValid(
        user?.userId && newPassword && newPassword.length > 5 ? true : false
      );
    }, [newPassword]);

    const submitCallback = (res: ApiResponse<boolean>) => {
      if (res && res.isSuccess && res.data) {
        setShowModal(false);
        ShowAlert.Success("Password changed successfully.");
      } else ShowAlert.Error("Request failed: " + res.message);
    };

    const handleFormSubmit = () => {
      if (!isFormValid) ShowAlert.Error("Please enter valid password.");
      else changePasswordByUserId(user.userId, newPassword, submitCallback);
    };

    return (
      <Modal
        show={show}
        onHide={() => setShowModal(false)}
        centered
        scrollable
        dialogClassName="modal-sm"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h4>Change Password</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div className="row">
              <div className="col-sm-12">
                <div className="panel panel-default">
                  <div className="panel-body">
                    <form autoComplete="off">
                      <h5>{user.userName}</h5>
                      <div className="form-floating">
                        <input
                          type="password"
                          className="form-control"
                          id="nPwd"
                          placeholder="New Password"
                          value={newPassword}
                          autoComplete="off"
                          onChange={(e) => setNewPassword(e.target.value)}
                        />
                        <label htmlFor="nPwd">New Password</label>
                      </div>
                      <div className="small text-muted">
                        *minimum 6 characters length
                      </div>
                      <div className="btn-group d-flex mt-3">
                        <button
                          onClick={handleFormSubmit}
                          className="btn btn-default rounded-0 flex-fill"
                          disabled={!isFormValid}
                          type="button"
                        >
                          Submit
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
);

export default ChangePasswordAdmin;
